export default "__VITE_ASSET__84e6cd44__"